import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import { useNavigate } from 'react-router-dom';
import ProfilArbitre from './profilArbitre';

function AccueilArbitre() {
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const Navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          {
            withCredentials: true // Permet de transmettre les cookies avec la requête
          }
        );
        setUserData(response.data);
        setError(null);
        if (response.data.user.type !== "arbitre"){
            Navigate('/connexion')
            
          }
      } catch (error) {
        if (error.response) {   
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        Navigate('/connexion')

      }
    };

    fetchData(); 
  }, [Navigate, apiUrl]); 


  return (
    <>
      {userData ? (
       <> 
          <ProfilArbitre userData={userData}/>
        </>
      ) : (
        <>
        <Navigation/>        
        <div id="alert-message" className="alert" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
        </>
      )}
    </>
  );
}

export default AccueilArbitre;
